export default __webpack_public_path__ + "images/student/avatars/Blu-6680d1a108a8b1832eebc3ef1e8ccc8e.svg";